import Calendar from '@/components/ezuro/workschedule/components/Calendar.vue';
import Department from '@/components/ezuro/workschedule/components/Department.vue';
import RecordEdit from '@/components/ezuro/workschedule/components/edit/RecordEdit.vue';
import DateFor from '@/components/ezuro/workschedule/components/edit/DateFor.vue';
import CopySchedule from '@/components/ezuro/schedule/CopySchedule.vue';
import ScheduleNotesEdit from '@/components/ezuro/workschedule/components/edit/ScheduleNotesEdit.vue';

export default {
  name: 'Content',
  props: {
    view: {
      type: String
    },
    section: {
      type: String
    },
    filterData: {
      type: Object
    },
    scheduleData: {
      type: Object | Array
    },
    isLoading: {
      type: Boolean
    },
    workScheduleType: {
      type: String
    }
  },
  components: {
    Calendar,
    Department,
    RecordEdit,
    DateFor,
    CopySchedule,
    ScheduleNotesEdit
  },
  data () {
    return {
      somethingChanged: false,
      schedules: {},
      scheduleFullData: null
    }
  },
  computed: {
    departmentsInOrder () {
      const output = [];
      const allDivisions = this.$store.getters.getConfigOptions('company_divisions', this.$i18n.locale, null, null, false, false, false, ['department_id']);

      this.schedules = {};

      if (this.scheduleData.departments) {
        for (const departmentId of this.scheduleData.departments) {
          const departmentName = this.$store.getters.getParamFromConfig('company_departments', departmentId, 'name', this.$i18n.locale);
          const departmentDivisions = allDivisions.filter(
            el => (
              (!this.filterData.division_id || (!this.filterData.division_id.length || this.filterData.division_id.includes(parseInt(el.value)))) &&
              departmentId === parseInt(el.department_id)
            )
          );

          if (!this.filterData.division_id || (this.filterData.division_id && !this.filterData.division_id.length)) {
            if (this.section != 'list-my' || Object.values(this.scheduleData.users[departmentId]).length) {
              this.schedules[departmentId] = null;
              output.push({ id: departmentId, name: departmentName });
            }
          }

          for (const key in departmentDivisions) {
            const scheduleKey = departmentId + '_' + departmentDivisions[key].value;

            if (this.section != 'list-my' || Object.values(this.scheduleData.users[scheduleKey]).length) {
              this.schedules[scheduleKey] = null;
              output.push({ id: scheduleKey, name: departmentName + ' - ' + departmentDivisions[key].text });
            }
          }

          for (const schedule of this.scheduleData.schedules) {
            if (schedule.department_id == departmentId) {
              this.schedules[departmentId + (schedule.division_id ? '_' + schedule.division_id : '')] = schedule;
            }
          }
        }
      }

      return this.BasicHelper.sortArrayByKeyValue(output, 'name');
    },
    layoutSettings () {
      return this.$store.state.hr.ezLayoutSettings;
    },
    tdWidth () {
      return this.layoutSettings.tdWidth;
    }
  },
  methods: {
    updateScheduleData (data) {
      this.scheduleFullData = data;
    },
    getDepartmentId (key) {
      if (typeof key === 'string') {
        const parts = key.split('_');
        return parseInt(parts[0]);
      }

      return parseInt(key);
    },
    getDivisionId (key) {
      if (typeof key === 'string') {
        const parts = key.split('_');
        return (parts[1] ? parseInt(parts[1]) : null);
      }

      return null;
    },
    getScheduleById (id) {
      for (const key in this.scheduleData.schedules) {
        if (this.scheduleData.schedules[key].id === id) {
          return this.scheduleData.schedules[key];
        }
      }
    },
    getScheduleByDepartmentId (id) {
      for (const key in this.scheduleData.schedules) {
        if (this.scheduleData.schedules[key].department_id === id) {
          return this.scheduleData.schedules[key];
        }
      }
    },
    editRecord (data) {
      if (this.section == 'list-my') return;
      this.$refs.editRecord.show(data);
    },
    addRecord (data) {
      if (this.section == 'list-my') return;
      this.$refs.editRecord.show(data);
    },
    addNotes (sqlDay) {
      if (this.section == 'list-my') return;
      this.$refs.editNotes.show(sqlDay);
    },
    editNotes (data) {
      if (this.section == 'list-my') return;
      this.$refs.editNotes.show(data.sqlDay, data);
    },
    downloadExcel (params) {
      this.isFilePreparing = true;
      this.ApiRequest.request(
        `ezuro/schedule/row/list/download-excel?mode=${params.mode}`,
        this.ApiRequest.REQUEST_DOWNLOAD,
        { data: this.scheduleData, fulldata: this.scheduleFullData },
        (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          }
          this.isFilePreparing = false;
        });
    },
    changed: function () {
      this.somethingChanged = true;
    },
    checkChanges: function () {
      if (this.somethingChanged) {
        this.somethingChanged = false;
        this.filter();
      }
    },
    filter: function () {
      this.$emit('filter');
    },
    editDateFor (id) {
      const schedule = this.getScheduleById(id);
      this.$refs.dateForModal.show(schedule.id, schedule.date_for, schedule.status === 'draft');
    },
    updateDateFor (data) {
      const schedule = this.getScheduleById(data.id);
      schedule.date_for = data.dateFor;
    },
    deleteSchedule (data, approved) {
      const schedule = this.getScheduleById(data.id);

      if (approved) {
        this.ApiRequest.request('ezuro/schedule/destroy/' + schedule.id, this.ApiRequest.REQUEST_GET, {}, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.filter();
          }
        });
      } else {
        this.$refs.scheduleDeleteMsgBox.show(
          data,
          this.$t('work-schedule.scheduleDeleteTitle', {
            scheduleType: this.$t('work-schedule.delete.' + schedule.type)
          }),
          this.$t('work-schedule.scheduleDeleteMessage', {
            scheduleType: this.$t('work-schedule.delete.' + schedule.type),
            departmentName: this.$store.getters.getParamFromConfig('company_departments', schedule.department_id, 'name', this.$i18n.locale)
          })
        )
      }
    },
    getTeams (departmentId, divisionId) {
      const out = [];
      for (const team of this.scheduleData.teams) {
        if (team.department_id != departmentId || team.division_id != divisionId) {
          continue;
        }
        out.push(team);
      }
      return out;
    },
    copySchedule (id) {
      const schedule = this.getScheduleById(id);
      this.$refs.copyScheduleModal.show(schedule.id, schedule.type, this.getTeams(schedule.department_id, schedule.division_id));
    },
    setLoading: function (value) {
      this.$emit('loading', value);
    },
    toggleTotals () {
      this.$store.dispatch('toggleShowTotals').then(() => {
        this.calculateTdWidth();
      });
    },
    calculateTdWidth () {
      let tdwidth = 41;
      if (!this.layoutSettings.showTotals) {
        const nameSurname = this.$el.querySelector('th.table_name_surname');
        const jobPosition = this.$el.querySelector('th.table_job_position');
        const table = this.$el.querySelector('.table_wrap');
        tdwidth = 41;
        if (nameSurname && jobPosition && table) {
          const firstThead = this.$el.querySelector('thead');
          const firstTr = firstThead ? firstThead.querySelector('tr') : null;
          const days = firstTr.querySelectorAll('th.th-day').length;
          const tableWidth = table.getBoundingClientRect().width;
          tdwidth = Math.ceil((tableWidth - nameSurname.getBoundingClientRect().width - jobPosition.getBoundingClientRect().width) / days);
          tdwidth = Math.max(tdwidth, 41);
        }
      }
      this.$store.commit('SET_TDWIDTH', tdwidth);
    }
  },
  mounted () {
    window.addEventListener('resize', this.calculateTdWidth);
  }
}
